import { render, staticRenderFns } from "./WebScrap.vue?vue&type=template&id=640d7df3&scoped=true"
import script from "./WebScrap.vue?vue&type=script&lang=js"
export * from "./WebScrap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640d7df3",
  null
  
)

export default component.exports